<div class="heatmap-card">
    <div class="heatmap-header">
        <h3 class="chart-title">{{ 'request_v2.analytics.heatmap_title' | translate }}</h3>
        <div class="category-tabs" *ngIf="categories.length > 0">
            <button *ngFor="let tab of categoryTabs"
                    class="category-tab"
                    [class.active]="selectedCategoryId === tab.id"
                    (click)="onCategoryFilter(tab.id)">
                {{ tab.name }}
            </button>
        </div>
    </div>
    <div class="heatmap-container">
        <div id="analytics-heatmap" class="map"></div>
        <div *ngIf="filteredPoints.length === 0" class="no-data-overlay">
            {{ 'request_v2.analytics.no_data' | translate }}
        </div>
    </div>
    <div class="heatmap-footer">
        <span class="point-count">{{ filteredPoints.length }} {{ 'request_v2.analytics.heatmap_points' | translate }}</span>
    </div>
</div>
